import { IClientConfig } from '../../../../config/clientConfig';
import { IRewardsBalanceResponse } from '../../rewardsClub.interface';
import { ErrorResolution } from '..//../../../app/common/errorResolution/errorResolution';

export enum RewardsBalanceActionTypes {
    LOADING_CASHBACK_AND_POINTS_PAGE = 'LOADING_CASHBACK_AND_POINTS_PAGE',
    GET_ALL_REWARDS_BALANCES_REQUEST = 'GET_ALL_REWARDS_BALANCES_REQUEST',
    GET_ALL_REWARDS_BALANCES_SUCCESS = 'GET_ALL_REWARDS_BALANCES_SUCCESS',
    GET_ALL_REWARDS_BALANCES_FAILURE = 'GET_ALL_REWARDS_BALANCES_FAILURE',
}

export type RewardsBalanceAction =
    | {
          type: RewardsBalanceActionTypes.LOADING_CASHBACK_AND_POINTS_PAGE;
      }
    | {
          type: RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_REQUEST;
      }
    | {
          type: RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_SUCCESS;
          rewardsBalanceResponse: IRewardsBalanceResponse[];
          clientConfig: IClientConfig;
          meta: { rat: Record<string, any> };
      }
    | {
          type: RewardsBalanceActionTypes.GET_ALL_REWARDS_BALANCES_FAILURE;
          error: ErrorResolution;
      };
